import React from 'react'
import { HCCategories } from '_constants'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { helpCenterActions } from '_actions';
import { HelpCenterCategoryTab } from './CategoryTab';

class HelpCenterCategoryList extends React.Component {

    render() {
        // const list = HCCategories.map((category) => {
        //     return (
        //         <HelpCenterCategoryTab
        //             key={category.id}
        //             categoryId={category.id}
        //             name={category.name}
        //             changeCategory={this.props.changeCategory}
        //             selected={this.props.selectedCategory === category.id ? true : false} />
        //     );
        // });

        return (
            <div>
                {Object.keys(this.props.categoryList)
                    .map(id => {
                        const result = this.props.categoryList[id];
                        return <HelpCenterCategoryTab
                            key={result.id}
                            categoryId={result.id}
                            name={result.name}
                            changeCategory={this.props.changeCategory}
                            selected={this.props.selectedCategory === result.id ? true : false} />
                    })
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        changeCategory: bindActionCreators(helpCenterActions.categoryChange, dispatch)
    };
}

function mapStateToProps(state) {
    let categoryList = Object.keys(HCCategories)
        .filter(x => HCCategories[x].enabled === true)
        .map(x => HCCategories[x]);

    return {
        categoryList,
        selectedCategory: state.ui.helpCenter.selectedCategory
    };
}

const connectedHelpCenterCategoryList = connect(mapStateToProps, mapDispatchToProps)(HelpCenterCategoryList);
export { connectedHelpCenterCategoryList as HelpCenterCategoryList };
